import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-lg-10 mx-auto" }
const _hoisted_4 = { class: "pb-10 pb-lg-15" }
const _hoisted_5 = { class: "d-flex flex-column flex-lg-row justify-content-between align-items-lg-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark" }, [
    /*#__PURE__*/_createTextVNode(" Provide First Name, Last Name and Country "),
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-exclamation-circle ms-2 fs-7",
      "data-bs-toggle": "tooltip",
      title: "Billing is issued based on your selected account type"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-semobold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://morrisonrecordsbureau.com/contact-us/",
      target: "_blank",
      class: "link-primary fw-bold"
    }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_7 = { class: "d-flex gap-3 mt-lg-0 mt-6" }
const _hoisted_8 = ["data-bs-target"]
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Add Verification ")
const _hoisted_11 = {
  class: /*#__PURE__*/_normalizeClass(`badge badge-primary`)
}
const _hoisted_12 = ["onClick", "data-bs-target"]
const _hoisted_13 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Edit ")
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Delete ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ExcelParser = _resolveComponent("ExcelParser")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_AMLVerificationForm = _resolveComponent("AMLVerificationForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success btn-sm",
                  "data-bs-toggle": "modal",
                  "data-bs-target": `#${_ctx.$modals.AML_VERIFICATION_FORM_MODAL}`,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.addRecord($event)))
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Plus.svg" })
                  ]),
                  _hoisted_10
                ], 8, _hoisted_8),
                _createVNode(_component_ExcelParser, {
                  label: "Bulk Upload",
                  "upload-help-text": "Upload an excel sheet containing information of your verifications",
                  "upload-critical-text": "Ensure your sheet contains columns for First Name, Last Name and Country",
                  "required-cols": ['First Name', 'Last Name', 'Country'],
                  "example-sheet": $setup.idVerififcationUploadSheetUrl,
                  onChange: $setup.bulkAddRecords
                }, null, 8, ["example-sheet", "onChange"])
              ])
            ])
          ]),
          (_openBlock(), _createBlock(_component_Datatable, {
            "table-header": $setup.tableHeader,
            "table-data": $props.verifications,
            "rows-per-page": 5,
            "enable-items-per-page-dropdown": false,
            "empty-table-text": "No verifications added",
            total: $props.verifications.length,
            key: $setup.tableKey
          }, {
            "cell-first_name": _withCtx(({ row: verification }) => [
              _createTextVNode(_toDisplayString(verification.first_name), 1)
            ]),
            "cell-last_name": _withCtx(({ row: verification }) => [
              _createTextVNode(_toDisplayString(verification.last_name), 1)
            ]),
            "cell-country": _withCtx(({ row: verification }) => [
              _createElementVNode("span", _hoisted_11, _toDisplayString(verification.country), 1)
            ]),
            "cell-edit": _withCtx(({ row: verification }) => [
              _createElementVNode("button", {
                onClick: _withModifiers(($event: any) => ($setup.editRecord(verification)), ["stop"]),
                class: "btn btn-sm btn-light btn-active-light-primary m-1",
                "data-bs-toggle": "modal",
                "data-bs-target": `#${_ctx.$modals.AML_VERIFICATION_FORM_MODAL}`
              }, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                ]),
                _hoisted_14
              ], 8, _hoisted_12),
              _createElementVNode("a", {
                onClick: ($event: any) => ($setup.deleteRecord(verification.id)),
                class: "btn btn-sm btn-light btn-active-light-primary m-1"
              }, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                ]),
                _hoisted_17
              ], 8, _hoisted_15)
            ]),
            _: 1
          }, 8, ["table-header", "table-data", "total"]))
        ])
      ])
    ]),
    _createVNode(_component_AMLVerificationForm, {
      "initial-data": $setup.selectedRow || {}
    }, null, 8, ["initial-data"])
  ], 64))
}